import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';
import { PASSWORD_DIGIT_REGEX, PASSWORD_LETTER_REGEX, PASSWORD_MIN } from '@forest/contracts';

/** Live checklist of the password rules, driven by the contract constants. */
export function PasswordRules({ value }: { value: string }) {
  const { t } = useTranslation('common');

  const rows = [
    { key: 'validation.password.rule.length', met: value.length >= PASSWORD_MIN },
    { key: 'validation.password.rule.letter', met: PASSWORD_LETTER_REGEX.test(value) },
    { key: 'validation.password.rule.digit', met: PASSWORD_DIGIT_REGEX.test(value) },
  ];

  return (
    <ul aria-live="polite" className="mt-1 space-y-0.5 text-xs">
      {rows.map((row) => (
        <li
          key={row.key}
          className={`flex items-center gap-1.5 ${
            row.met ? 'text-green-600 dark:text-green-400' : 'text-slate-500 dark:text-slate-400'
          }`}
        >
          {row.met ? <Check className="h-3 w-3" aria-hidden /> : <X className="h-3 w-3" aria-hidden />}
          {t(row.key)}
        </li>
      ))}
    </ul>
  );
}
